/**
 * Component | Tab Group
 * Manages tab selection and pane visibility
 */

import { IModule, component } from "@sygnal/sse";

const ACTIVE_CLASS = 'w-variant-be11be63-d42d-a34f-c120-8caef69c2021';

@component('tab-group')
export class TabGroupComponent implements IModule {
  private elem: HTMLElement;
  private tabs: HTMLElement[] = [];
  private panes: HTMLElement[] = [];

  constructor(elem: HTMLElement) {
    this.elem = elem;
  }

  setup(): void {}

  async exec(): Promise<void> {
    // Collect tab and pane elements
    const tabsContainer = this.elem.querySelector('[app="tabs"]');
    const panesContainer = this.elem.querySelector('[app="tab-panes"]');

    if (tabsContainer) {
      this.tabs = Array.from(tabsContainer.children) as HTMLElement[];
    }
    if (panesContainer) {
      this.panes = Array.from(panesContainer.children) as HTMLElement[];
    }

    // Bind click events on tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.selectTab(index);
      });
      tab.style.cursor = 'pointer';
    });

    // Auto-select first tab
    if (this.tabs.length > 0) {
      this.selectTab(0);
    }
  }

  private selectTab(index: number): void {
    // Update tab active states
    this.tabs.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add(ACTIVE_CLASS);
      } else {
        tab.classList.remove(ACTIVE_CLASS);
      }
    });

    // Show/hide panes
    this.panes.forEach((pane, i) => {
      pane.style.display = i === index ? '' : 'none';
    });

    // Override main image from active pane's image
    const paneImage = this.panes[index]?.querySelector<HTMLImageElement>('[app="image"]');
    if (paneImage?.src) {
      const decisionStep = this.elem.closest('[sse-component="decision-step"]');
      const mainImage = decisionStep?.querySelector<HTMLImageElement>('[app="main-image"]');
      if (mainImage) {
        mainImage.src = paneImage.src;
        mainImage.removeAttribute('srcset');
      }
    }
  }
}
